<script setup>
import { useLayout } from "src/composables/useLayout";
import { useUser } from "src/composables/useUser";
import AppConfigurator from "./AppConfigurator.vue";

const { onMenuToggle } = useLayout();
const { logout } = useUser();

const handleLogout = async () => {
  await logout();
};
</script>

<template>
  <div class="layout-topbar">
    <div class="layout-topbar-logo-container">
      <button class="layout-menu-button layout-topbar-action" @click="onMenuToggle">
        <i class="pi pi-bars"></i>
      </button>
      <router-link to="/" class="layout-topbar-logo">
        <span>Omnihub</span>
      </router-link>
    </div>

    <div class="layout-topbar-actions">
      <div class="layout-config-menu">
        <div class="relative">
          <button
            v-styleclass="{
              selector: '@next',
              enterFromClass: 'hidden',
              enterActiveClass: 'animate-scalein',
              leaveToClass: 'hidden',
              leaveActiveClass: 'animate-fadeout',
              hideOnOutsideClick: true,
            }"
            type="button"
            class="layout-topbar-action layout-topbar-action-highlight"
          >
            <i class="pi pi-cog" />
          </button>
          <AppConfigurator />
        </div>
        <div class="relative">
          <button
            type="button"
            class="layout-topbar-action layout-topbar-action-highlight"
            @click="handleLogout"
            title="Logout"
          >
            <i class="pi pi-sign-out" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
